import { AiOutlineArrowLeft } from "react-icons/ai";
import styled from "styled-components";

export const StyledAiOutlineArrowLeft = styled(AiOutlineArrowLeft)({
  marginRight: "15px",
  width: "25px",
  height: "25px",
  cursor: "pointer",
});
